import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Upload, 
  FileText, 
  ClipboardList, 
  Clock, 
  Users, 
  TrendingUp,
  CheckCircle,
  AlertCircle
} from 'lucide-react';

export const DashboardPage: React.FC = () => {
  const stats = [
    {
      name: 'Всего стенограмм',
      value: '—',
      change: 'в разработке',
      changeType: 'neutral',
      icon: FileText,
    },
    {
      name: 'Создано протоколов',
      value: '—',
      change: 'скоро появится',
      changeType: 'neutral',
      icon: ClipboardList,
    },
    {
      name: 'Среднее время обработки',
      value: '—',
      change: 'оптимизация',
      changeType: 'neutral',
      icon: Clock,
    },
    {
      name: 'Активных пользователей',
      value: '—',
      change: 'тестирование',
      changeType: 'neutral',
      icon: Users,
    },
  ];

  const recentActivities = [
    {
      id: 1,
      type: 'transcription',
      title: 'Заседание кафедры математики',
      time: '2 часа назад',
      status: 'completed',
    },
    {
      id: 2,
      type: 'protocol',
      title: 'Протокол совета факультета',
      time: '4 часа назад',
      status: 'completed',
    },
    {
      id: 3,
      type: 'transcription',
      title: 'Встреча с деканом',
      time: '6 часов назад',
      status: 'processing',
    },
  ];

  const quickActions = [
    {
      name: 'Загрузить файл',
      description: 'Извлечь стенограмму из файла',
      href: '/upload',
      icon: Upload,
      color: 'bg-blue-500',
    },
    {
      name: 'Просмотреть стенограммы',
      description: 'Все созданные стенограммы',
      href: '/transcriptions',
      icon: FileText,
      color: 'bg-green-500',
    },
    {
      name: 'Управление протоколами',
      description: 'Создание протоколов',
      href: '/protocols',
      icon: ClipboardList,
      color: 'bg-purple-500',
    },
  ];

  return (
    <div className="space-y-8">
      {/* Заголовок */}
      <div>
        <h1 className="text-3xl font-bold text-secondary-900">Панель управления</h1>
        <p className="mt-2 text-secondary-600">
          Добро пожаловать в РЕШИЛИ:
        </p>
        <p className="mt-2 text-secondary-600">
          Раздел находится в активной разработке 🚧
          Скоро здесь появятся аналитика, статистика и быстрые действия.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        {/* Быстрые действия */}
        <div className="card">
          <h2 className="text-lg font-semibold text-secondary-900 mb-4">Быстрые действия</h2>
          <div className="space-y-3">
            {quickActions.map((action) => {
              const Icon = action.icon;
              return (
                <Link
                  key={action.name}
                  to={action.href}
                  className="flex items-center p-4 rounded-lg border border-secondary-200 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200"
                >
                  <div className={`flex-shrink-0 w-10 h-10 ${action.color} rounded-lg flex items-center justify-center`}>
                    <Icon className="h-5 w-5 text-white" />
                  </div>
                  <div className="ml-4 flex-1">
                    <h3 className="text-sm font-medium text-secondary-900">{action.name}</h3>
                    <p className="text-sm text-secondary-600">{action.description}</p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>

        {/* Последние активности */}
        <div className="card flex flex-col items-center justify-center py-16">
          <p className="text-secondary-600 text-center text-lg">
            Раздел <span className="font-medium text-secondary-900">«Последние активности» </span>
            тоже находится в разработке.
          </p>
          <p className="mt-2 text-secondary-500">Скоро вы сможете видеть свои действия здесь.</p>
        </div>
      </div>
    </div>
  );
};
